import { render, staticRenderFns } from "./QuickCouponComponent.vue?vue&type=template&id=b8f9366e&scoped=true&"
import script from "./QuickCouponComponent.vue?vue&type=script&lang=ts&"
export * from "./QuickCouponComponent.vue?vue&type=script&lang=ts&"
import style0 from "./QuickCouponComponent.vue?vue&type=style&index=0&id=b8f9366e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f9366e",
  null
  
)

export default component.exports